export default __webpack_public_path__ + "static/media/pic4.3bb7ab85.png";